export async function getSummary (params = {}) {
  return await axios.get('/reports/company-summary', {
    params,
  }).then(res => res.data);
}

export async function getTasksReportSummary (params = {}) {
  return await axios.get('/reports/tasks/summary', {
    params,
  }).then(res => res.data);
}

export async function getTasks (params = {}) {
  return await axios.get('/reports/tasks', {
    params,
  }).then(res => res.data);
}

export async function get (params = {}) {
  return await axios.get('/reports/monthly', {
    params,
  }).then(res => res.data);
}

export async function getBreakdown (params = {}) {
  return await axios.get('/reports/breakdown', {
    params,
  }).then(res => res.data);
}
